export default __webpack_public_path__ + "static/media/arrow-up.4172f8c3.svg";